@if (relatedAccounts()?.length > 0) {
  <a role="button"
     class="td-wb-dividends-related-accounts__link"
     tabindex="0"
     [tdWbOverlayAsync]="true"
     tdWbOverlayPosition="end-bottom"
     [tdWbOverlayToggle]="relatedAccountsOverlay"
     (tdWbOverlayAsyncOpen)="onAccountsOverlayOpen($event)">
    <span translate="tdWb.accounts.dividends.relatedAccounts.SHOW_ACCOUNTS"></span>
  </a>
} @else {
  <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
}
<ng-template #relatedAccountsOverlay>
  <td-wb-overlay>
    <td-wb-overlay-header class="td-wb-dividends-related-accounts__header">
      <span translate="tdWb.accounts.dividends.relatedAccounts.HEADER"
            [translateParams]="{ symbolName: symbolName() }"></span>
    </td-wb-overlay-header>
    <div class="td-wb-dividends-related-accounts__description"
         translate="tdWb.accounts.dividends.relatedAccounts.DESCRIPTION"
         [translateParams]="{ symbolName: symbolName() }"></div>
    <td-wb-list listSize="compact">
        @for (account of accounts() ?? []; track trackByAccount($index, account)) {
          <td-wb-list-item>
            <td-wb-list-item-label>
              <a [tdWbHref]="isDIAccount(account) ? 'link_dividends' : 'link_holdings'"
                 [tdWbHrefParams]="{ accountId: account.id }"
                 class="td-wb-dividends-related-accounts__list-item-link">
                <td-wb-account-label [account]="account"
                                     type="short" />
              </a>
            </td-wb-list-item-label>
          </td-wb-list-item>
        }
      </td-wb-list>
  </td-wb-overlay>
</ng-template>

